import { configureStore } from '@reduxjs/toolkit';

import { mainReducer } from './reducers/mainHandler';

export const store = configureStore({
  reducer: {
    main: mainReducer,
  },
  // TODO: Check serializable data on modals and prefer not using such data
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});
